module.exports = __webpack_public_path__ + "static/media/animal-jaguar2.5056b6fc.aac";